// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1PlYS","title":"card_title__2vuW-","inActive":"card_inActive__1ktSJ"};